import { format, formatDuration, intervalToDuration } from 'date-fns';
import React from 'react';
import { trpc } from '../../utils/trpc';

const Jobs = () => {
  const jobs = trpc.worker.jobs.useQuery(undefined, { refetchInterval: 5000 });

  return (
    <div className="flex flex-col">
      <div className="flex-row mt-5">
        <div className="flex-grow text-center">
          <p className="text-center text-2xl">Recent Jobs</p>
        </div>
      </div>
      <div className="m-6" />
      <div className="flex-row">
        <div className="relative overflow-x-auto">
          {!jobs.data && <p>Loading</p>}
          {jobs.isSuccess && (
            <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
              <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                  <th scope="col" className="px-6 py-3">
                    Job ID
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Owner
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Start
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Duration
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Status
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Errors
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Environment
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Stocker Version
                  </th>
                </tr>
              </thead>
              <tbody>
                {jobs.data &&
                  jobs.data.map((job) => (
                    <tr key={job.job_id} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                      <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                        {job.job_id ? `${job.job_id.substring(0, 6)} ...` : 'N/A'}
                      </th>
                      <td className="px-6 py-4">{job.job_meta?.PRINCIPAL?.email}</td>
                      {job.job_meta?.CONTAINER_ATTRS ? (
                        <td className="px-6 py-4">{format(job.job_meta?.CONTAINER_ATTRS?.state.StartedAt!, 'PPpp')}</td>
                      ) : (
                        <td className="px-6 py-4">-</td>
                      )}
                      {job.job_meta?.CONTAINER_ATTRS ? (
                        <td className="px-6 py-4">
                          {formatDuration(
                            intervalToDuration({
                              start: job.job_meta?.CONTAINER_ATTRS?.state.StartedAt!,
                              end: job.job_meta?.CONTAINER_ATTRS?.state.FinishedAt!
                            })
                          )}
                        </td>
                      ) : (
                        <td className="px-6 py-4">-</td>
                      )}
                      <td className="px-6 py-4">{job.job_status}</td>
                      {job.job_meta?.CONTAINER_ATTRS ? (
                        <td className="px-6 py-4">{job.job_meta?.CONTAINER_ATTRS?.state.ExitCode}</td>
                      ) : (
                        <td className="px-6 py-4">-</td>
                      )}
                      <td className="px-6 py-4">{job.job_meta?.JOB?.env}</td>
                      {job.job_meta?.CONTAINER_ATTRS ? (
                        <td className="px-6 py-4">{job.job_meta?.CONTAINER_ATTRS?.image.split(':')[1]}</td>
                      ) : (
                        <td className="px-6 py-4">-</td>
                      )}
                    </tr>
                  ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default Jobs;
